export default __webpack_public_path__ + "static/media/total-customers.8d61b942.svg";